import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { isCoverPageEnabled } from "@pathwright/web/src/modules/cover-pages/utils"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { ConnectStores } from "lib/core/store"
import AuthorList from "./AuthorList"

const AuthorListCard = ({
  card,
  baseURL,
  authors,
  authors_loading,
  updateAuthorOrder
}) => {
  const pwContext = usePathwrightContext()
  const coverPageEnabled = isCoverPageEnabled(pwContext)
  return (
    <Card
      title="Contributors"
      completeAction={{
        to: `${baseURL}new/`,
        children: "New Contributor"
      }}
      card={card}
    >
      {authors_loading ? (
        <LoadingCircle />
      ) : (authors != null ? authors.length : undefined) ? (
        <AuthorList
          baseURL={baseURL}
          authors={authors}
          updateAuthorOrder={updateAuthorOrder}
        />
      ) : (
        <BlankSlate
          heading="Your library doesn't have any contributors yet."
          body={`Create contributor profiles to share more about yourself or another course contributor who you'd like to highlight on your ${
            coverPageEnabled ? "Cover" : "About"
          } pages`}
        />
      )}
    </Card>
  )
}

AuthorListCard.displayName = "AuthorListCard"

const mapStateToProps = function (state, ownProps) {
  const { authors, authors_loading } = state.authorAdminStore.state
  const { updateAuthorOrder } = state.authorAdminStore.action
  const { url: baseURL } = state.navigationStore.state

  return _.assign(
    {},
    {
      baseURL,
      authors,
      authors_loading,
      updateAuthorOrder
    },
    ownProps
  )
}

const connectStores = [
  { store: "navigation", watch: ["url"] },
  { store: "authorAdmin", watch: ["authors", "authors_loading"] }
]

export default ConnectStores(AuthorListCard, connectStores, {}, mapStateToProps)
